import React from "react";

function About() {
    return (
        <div className="about-me">
            <p className="intro-about-me">About Me &#128540;</p>
            <div className="grid-container">
                <div className="grid-item">
                    <p className="about-me-paragraph">
                        Hello! My name is Emma and I enjoy creating things that live on the
                        internet. My interest in web development started back in 2018 when
                        I decided to try building a Bulk SMS platform — turns out hacking
                        a solution that solves a problem is a lot of fun! <br /><br />
                        Fast-forward to today, I switched from Accounting to Software development
                        and haven't looked back since. I've had the privilege of working at a
                        financial and technology consulting firm, living at the intersection of finance and technology.<br /><br />
                    </p>
                </div>
                <div className="grid-item">
                    <div className="progress-bars">
                        <div className="wrap-circles">
                            <div class="circle per-90">
                                <div class="inner">Python</div>
                            </div>
                            <div class="circle per-90">
                                <div class="inner">Django</div>
                            </div>
                            <div class="circle per-75">
                                <div class="inner">Flask</div>
                            </div>
                            <div class="circle per-80">
                                <div class="inner">C#</div>
                            </div>
                            <div class="circle per-85">
                                <div class="inner">ASP.Net</div>
                            </div>
                            <div class="circle per-75">
                                <div class="inner">JS</div>
                            </div>
                            <div class="circle per-80">
                                <div class="inner">Angular</div>
                            </div>
                            <div class="circle per-80">
                                <div class="inner">PGSql</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default About;